export default __webpack_public_path__ + "static/media/NHaasGroteskTXPro-75Bd.735104a2.ttf";